<div class="attachment-group-container">
  <div class="attachment-group-header">
    <seed-user-avatar
      [size]="32"
      [src]="group().avatar" />
    <div class="attachment-group-header-info">
      <span class="origin-name">{{ group().name }}</span>
      <span class="origin-desc"
        ><strong>Enviados pelo {{ originDescription() }} </strong> ·
        {{ group().attachments.length }}
        {{ 'arquivo' | pluralizador: group().attachments.length }}</span
      >
    </div>
  </div>
  <div class="attachment-cards-grid">
    @for (attachment of group().attachments; track attachment.id) {
      <aionz-attachment-card
        [attachment]="attachment"
        (download)="downloadAttachment.emit($event)" />
    }
  </div>
</div>
